import { Badge, DefaultTooltip } from 'twyne-new.ui';

import { getInfo, keyOf } from '@Components/Grid/components/Table/formatters';

export default function WinnerFormatter({ info }) {
  const { value } = getInfo(info)
  const id = keyOf(info, 'sca-winner')

  if (value === null) {
    return '--'
  }

  const { color, label, tip } = WINNER_STATUSES[value]

  return <DefaultTooltip content={tip}>
    <Badge id={id} variant='outline' color={color} size='sm'>
      {label}
    </Badge>
  </DefaultTooltip>
}

const WINNER_STATUSES = {
  true: {
    color: 'success',
    label: 'found',
    tip: 'The generated SCA Promotions ticket has a matched confirmed consumer ticket for this contest.',
  },
  false: {
    color: 'neutral',
    label: 'not found',
    tip: 'The generated SCA Promotions ticket was not matched to a confirmed consumer ticket for this contest.',
  },
}
